import React, { useState } from "react";
import Arrow from '../../assets/icons/accordion-arrow.svg'

type Props = {
    title?: React.ReactNode,
    children?: React.ReactNode
};

const Accordion = ({ title, children }: Props) => {
    const [active, setActive] = useState(false)
    const handleClick = () => {
        setActive(!active)
    };
    return (
        <div>
            <div onClick={handleClick} className={
                `${active ? 'bg-vibrant-green rounded-t-[10px] text-white pr-3 mt-4' : 'text-deep-blue'} 
                 w-full border-deep-blue-opacity-50 py-4 flex justify-between items-center text cursor-pointer 
                 font-subtitleTwo`}>
                <p className='subtitle-2-light w-full ml-4'>{title}</p>
                <div className={`${active? 'text-white rotate-180 mr-2': 'text-vibrant-green mr-5'} `}>
                    <Arrow fill="currentColor"/>
                </div>
            </div>
            <div onClick={handleClick} className={`${active ? "border-4 overflow-hidden border-t-0 border-disabled bg-white rounded-b-xl px-2": "hidden"}`}>
                {children}
            </div>
            <p className={`${active? 'hidden':'w-full border-[2px] rounded-full border-deep-blue border-opacity-25'}`}></p>
        </div>
    );
}

export default Accordion;
